
import AdminTransact from "../components/superadmin/AdminUserInvoice";

export default function SuperUserInvoice() {
  return (
    <div>
      <AdminTransact />
    </div>
  );
}
